<template>
  <div class="wra">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :with-header="false"
      direction="rtl"
      size="80%"
      id="addSucai"
      :destroy-on-close="true"
    >
      <el-container style="height: 100%">
        <el-header height="auto">
          <fw-header titles="收货" />
        </el-header>
        <el-main v-if="dataInfo">
          <basmsg :dataInfo="dataInfo" />
          <div class="main_bot">
            <div>
              <span style="margin-right:45px;color:#858585;">配送至</span>
              <span style="margin-right:15px">
                {{ (dataInfo.receipt_info && dataInfo.receipt_info.name) || "--" }}
              </span>
              <span style="margin-right:15px">
                {{ dataInfo.receipt_info && dataInfo.receipt_info.mobile }}
              </span>
              <span style="margin-right:15px">
                {{ dataInfo.receipt_info && dataInfo.receipt_info.province_name }}&nbsp;{{
                  dataInfo.receipt_info && dataInfo.receipt_info.city_name
                }}&nbsp;{{ dataInfo.receipt_info && dataInfo.receipt_info.area_name }}&nbsp;{{
                  dataInfo.receipt_info && dataInfo.receipt_info.address
                }}
              </span>
            </div>
            <div>
              发运单号:
              <span style="color:#333;margin-left:15px">
                {{ (dataInfo.shipping && dataInfo.shipping.serial_number) || "--" }}
              </span>
            </div>
          </div>

          <div>
            <receipt-goods-table
              :tableList="dataInfo.shipping && dataInfo.shipping.goods"
              ref="receiptGoodsTable"
            />
          </div>

          <div>
            <fw-title titles="收货附件" style="padding-top: 25px" />
            <el-row class="packzone">
              <el-col :span="2" style="color:#606266">
                <span class="konggefu"></span>
                图片
              </el-col>
              <el-col :span="22">
                <div style="padding: 0px 15px;display:flex">
                  <fwuploadphoto
                    v-if="photoflag"
                    @postImgMsg="postImgMsg"
                    :backShow="receipt_image"
                    :mustDelet="true"
                    :onlyLook="true"
                  />
                  <fwmobileupload suffix="photo" @succ="succ" />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-main>
        <el-footer>
          <el-row>
            <el-col :span="24" align="center">
              <el-button size="small" @click="close">取消</el-button>
              <el-button size="small" type="primary" @click="confirmBtn">提交</el-button>
            </el-col>
          </el-row>
        </el-footer>
      </el-container>
      <fw-inoutsup ref="fwInoutsup" />
      <fw-chosePeople ref="fw_chosePeople" />
    </el-drawer>
  </div>
</template>

<script>
import Basmsg from "./basmsg.vue";
import ReceiptGoodsTable from "./receiptGoodsTable.vue";
export default {
  name: "",
  components: {
    Basmsg,
    ReceiptGoodsTable,
  },
  props: {},
  created() {},
  mounted() {},
  data() {
    return {
      visible: false,
      callFn: null, //回调
      order_id: null,
      rowId: null,
      dataInfo: null,
      formLabelAlign: {},
      rules: {},
      receipt_image: [], //收货附件
      photoflag: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    open(data, callFn) {
      console.log(data);
      this.callFn = callFn;
      this.order_id = data.id;
      if (data && data.rowId) {
        this.rowId = data.rowId;
      }

      this.getDefault();
      this.getBasicInfo();
      this.visible = true;
    },
    getDefault() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      console.log(userInfo);
      this.receipt_image = [];
      this.dataInfo = null;
    },
    getBasicInfo() {
      let params = {
        order_id: Number(this.order_id),
        id: Number(this.rowId),
      };
      if (!this.rowId) {
        delete params.id;
      }
      this.$axios.get(`/shop/public/common/personal/wait_receipt_detail`, params).then(res => {
        if (res.data) {
          console.log(res.data);
          if (res.data.shipping) {
            res.data.shipping.goods.map(v => {
              v["is_input"] = true;
              v["isAdd"] = true;
              v["send_name"] = res.data.shipping.send_name;
              v["send_at"] = res.data.shipping.send_at;
              v["logistics_serial_number"] = res.data.shipping.logistics_serial_number;
              v["serial_number"] = res.data.serial_number;
              v["receipt_image"] = [];
              v.receipt_unit_name = v.unit_name
              v.receipt_quantity = v.quantity
              return v;
            });
          }
          this.dataInfo = res.data;
        }
      });
    },

    succ(val) {
      console.log(val);
      this.photoflag = false;
      this.receipt_image = [...this.receipt_image, ...val];
      this.$nextTick(() => {
        this.photoflag = true;
      });
      console.log(this.receipt_image);
    },
    postImgMsg(val) {
      console.log(val);
    },

    confirmBtn() {
      let receiptGoodsTable = this.$refs.receiptGoodsTable.tableList;
      console.log(receiptGoodsTable);
      let Flag = receiptGoodsTable.every(sendInfo => {
        return sendInfo.is_input === false;
      });
      if (!Flag) {
        return this.$message.warning("请先确认收货明细的操作");
      }

      let receipt_goods = receiptGoodsTable.map(v => {
        let obj = {
          order_shipping_goods_id: v.id, //订单发货记录物品id
          receipt_storage_batch_no: v.receipt_storage_batch_no, //收货-仓库批
          receipt_box_code: v.receipt_box_code, //收货-装箱号
          receipt_pack_code: v.receipt_pack_code, //收货-包装标识
          receipt_unit_name: v.receipt_unit_name, //收货-单位
          receipt_quantity: v.receipt_quantity, //收货-数量
          receipt_project_name: v.receipt_project_name, //收货-项目
          receipt_goods_batch_no: v.receipt_goods_batch_no, //收货-批次号
          receipt_goods_sn: v.receipt_goods_sn, //收货-序列号
          receipt_goods_expire: v.receipt_goods_expire, //收货-有效期
          storage_id: v.storage_id, //仓库id
          storage_serial_number: v.storage_serial_number, //仓库编号
          storage_name: v.storage_name, //仓库名称
          location_code: v.location_code, //库位
          receipt_image: v.receipt_image, //收货图片，前端自定义
        };
        return obj;
      });
      let params = {
        receipt_goods,
        id: Number(this.order_id),
        order_shipping_id: this.dataInfo.shipping.id, //订单发货记录id
        receipt_image: this.receipt_image, //收货图片，前端自定义
      };
      console.log(params);
      this.$axios.putJSON("/shop/public/common/personal/receipt", params).then(res => {
        if (res.code == 200) {
          console.log(res);
          this.visible = false;
          this.callFn && this.callFn(true);
        }
      });
    },
    close() {
      this.visible = false;
      this.dataInfo = null;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding-left: 25px;
  padding-right: 25px;
}
.main_bot {
  background-color: #fafafa;
  margin-top: 25px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 25px;
  div {
    display: flex;
    align-items: center;
  }
}
.packzone {
  padding: 10px 15px;
  .el-col {
    margin-bottom: 15px;
  }
}
.choseGongji {
  margin-top: 12px;
  position: relative;
  display: inline-block;
  width: 400px;
  margin-right: 3%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fafafa;
  & > p {
    color: #0088fe;
    line-height: 30px !important;
  }
  p {
    line-height: 24px;
  }
  & > i {
    position: absolute;
    top: -5px;
    right: -5px;
    color: #ccc;
    cursor: pointer;
  }

  & > div {
    display: flex;
    & > div:nth-child(1) {
      width: 100px;
    }
    & > div:nth-child(2) {
      overflow: hidden;
      flex: 1;
      p {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.btn {
  width: 400px;
  border-color: #409eff;
  color: #409eff;
  &:hover {
    background-color: #c0defc;
    font-weight: bolder;
  }
}
.logistics_bar {
  display: flex;
  align-items: center;
}
</style>
